import React, {forwardRef} from 'react';
import classNames from 'classnames';
import Loader from './Loader';

const themes = {
  contained: 'btn-contained',
  outlined: 'btn-outlined',
  flat: 'btn-flat',
  flatLight: 'btn-flat-light',
};

const Button = forwardRef(function _Button(props, ref) {
  const {
    children,
    className: customClassNames = '',
    loading = false,
    type = 'button',
    variant = 'contained',
    disabled = false,
    ...restProps
  } = props;

  return (
    <button
      type={type}
      ref={ref}
      className={classNames(themes[variant], customClassNames)}
      disabled={disabled || loading}
      {...restProps}
    >
      {loading && (
        <span className="absolute-center" aria-label="loader-container">
          <Loader />
        </span>
      )}
      <span
        className={
          'flex flex-row items-center gap-2' +
          classNames({
            'opacity-0': loading,
          })
        }
      >
        {children}
      </span>
    </button>
  );
});

export default Button;
